import React from 'react'
import './Register.css'
const Register = () => {
  return (
    <section className='RegisterNow'>
        <div className="register-continer">
        <div className="Register-text">
            <span>Register now to get more deals</span>
            <span>Where health, beauty and fitness meet.</span>
            <button className='btn regbtn'>Appointment</button>
        </div>
        </div>
      
    </section>
  )
}

export default Register